/**
 * Shared constants derived from type definitions.
 * Import these instead of hardcoding option arrays in pages/components.
 */
import type {
	Asset,
	Chain,
	CustodialType,
	IntegrationStatus,
	MAURange,
	OnboardingStatus,
	Product,
	WishlistStatus,
} from "../types";

export const CHAINS: Chain[] = ["Stellar", "Solana", "Polygon"];

export const ASSETS: Asset[] = ["USDC", "USDT", "EURC", "ETH", "SOL"];

export const PRODUCTS: Product[] = ["Deposit", "Withdraw"];

export const CUSTODIAL_TYPES: CustodialType[] = ["Custodial", "Non-Custodial"];

export const INTEGRATION_STATUSES: IntegrationStatus[] = [
	"New - Pre-Integration",
	"Integrating",
	"Testing",
	"Ready to Go Live",
	"Live",
	"On-Hold",
	"Abandoned",
];

export const ONBOARDING_STATUSES: OnboardingStatus[] = [
	"Not Started",
	"Onboarding in Progress",
	"Onboarded",
];

export const WISHLIST_STATUSES: WishlistStatus[] = [
	"Sandbox",
	"Preview",
	"Production",
];

export const MAU_RANGES: MAURange[] = [
	"0-10K",
	"10K-50K",
	"50K-100K",
	"100K-500K",
	"500K-1M",
	"1M+",
];

/** Stellar public key pattern (G + 55 base32 chars). */
export const STELLAR_PUBLIC_KEY_REGEX = /^G[A-Z2-7]{55}$/;
